import React, { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Loading,
  LoadingLayout,
  CheckoutLayout
} from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';
import { useLocalization } from 'redux/localization/utils/hooks';
import { getReservationCart } from 'redux/reservationCart/actions';

const LoadableComponent = lazy(() => retry(() => import('./App')));

const AppLoader = () => {
  const dispatch = useDispatch();
  const { t } = useLocalization();

  useEffect(() => {
    dispatch(getReservationCart());
  }, [dispatch]);

  const reservationCartReducer = useSelector((state) => state.reservationCart);

  if (!reservationCartReducer.data) {
    return <LoadingLayout />;
  }

  return (
    <CheckoutLayout title={t('reservation.checkout.reservationCheckout')}>
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </CheckoutLayout>
  );
};

export default AppLoader;
